<template>
  <!-- 课程详情 -->
  <div class="index-container" v-loading="loading">
    <bannerImg
      :bannerText="bannerText"
      v-if="detailInfo.cover"
      :bannerCover="detailInfo.cover"
      :isShowTab="false"
    ></bannerImg>
    <div class="course-container" v-if="detailInfo">
      <div class="nav-box">
        首页 > 大健康人才培训 > 课程列表
        <span>> {{ detailInfo.title }}</span>
      </div>
      <div class="detail-title">{{ detailInfo.title }}</div>
      <div class="video-content">
        <div class="video-box">
          <el-carousel height="662PX">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <div
                class="v-img"
                :style="{ backgroundImage: 'url( ' + imgUrl + item + ')' }"
              ></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="detail-info-box">
        <div
          v-if="detailInfo['teacher'] && detailInfo['teacher'].length > 0"
          class="info-img"
          :style="{
            backgroundImage:
              'url( ' + imgUrl + detailInfo['teacher'][0]['avatar'] + ')',
          }"
        ></div>
        <div
          class="module-box"
          v-if="detailInfo['teacher'] && detailInfo['teacher'].length > 0"
        >
          <div class="name">授课讲师</div>
          <div>
            {{
              detailInfo["teacher"].length > 0
                ? detailInfo["teacher"][0]["name"]
                : "暂无"
            }}
          </div>
        </div>
        <div class="line">|</div>
        <div class="module-box">
          <div class="name">课程评分</div>
          <div>
            {{ detailInfo.evaluate_avg }}
            <span>（{{ detailInfo.count_evaluate }}人评价）</span>
          </div>
        </div>
        <div class="line">|</div>
        <div
          class="module-box"
          v-if="detailInfo['cate'] && detailInfo['cate'].length > 0"
        >
          <div class="name">课程类别</div>
          <div>
            {{ detailInfo.cate.length > 0 ? detailInfo.cate[0].title : "暂无" }}
          </div>
        </div>
        <div class="line">|</div>
        <div class="module-box">
          <div class="name">报名人数</div>
          <div>{{ detailInfo.report_count ? detailInfo.report_count : 0 }}</div>
        </div>
        <div class="sign-up-button" @click="signUp">立即报名</div>
      </div>
      <div class="detail-content">
        <div class="left-box">
          <div class="detail-module">
            <div class="d-title">课程概述</div>
            <div class="second-title">师资力量</div>
            <div class="teacher-box" v-if="detailInfo.faculty">
              <div
                class="t-list"
                v-for="(item, index) in detailInfo.faculty"
                :key="index + 'faculty'"
              >
                <div
                  class="teacher-img"
                  :style="{
                    backgroundImage: 'url( ' + imgUrl + item.img + ')',
                  }"
                ></div>
                <div class="teacher-words">
                  <div class="t-name">{{ item.name }}</div>
                  <div>{{ item.detail }}</div>
                </div>
              </div>
            </div>
            <div class="second-title">课程简介</div>
            <div class="intro-words" v-html="detailInfo.detail"></div>
            <div class="second-title">场地介绍</div>
            <div class="img-box" v-if="detailInfo.venues">
              <div
                class="img-list"
                v-for="(item, index) in detailInfo.venues"
                :key="'img' + index"
                @click="lookCard(item)"
                :style="{ backgroundImage: 'url( ' + imgUrl + item + ')' }"
              ></div>
            </div>
          </div>
          <div class="detail-module">
            <div class="d-title">课程目录</div>
            <div
              v-for="(item, index) in detailInfo.section"
              :key="index + 'one'"
            >
              <el-collapse>
                <el-collapse-item
                  :name="index"
                  v-if="item.child && item.child.length"
                >
                  <template slot="title">
                    <div class="second-title" :key="index + 'one'">
                      <!-- {{ item.level_id }} {{ item.level_name }} -->
                      {{ getSectionTitle(detailInfo, item, index) }}
                    </div>
                  </template>
                  <div
                    class="q-words"
                    :key="index.catalogue"
                    v-for="(item, index) in item.child"
                  >
                    <div
                      class="q-type"
                      :class="item.class_model === 1 ? 'type-green' : ''"
                    >
                      {{ item.class_model === 1 ? "线上" : "线下" }}
                    </div>
                    {{ item.name }}
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="detail-module">
            <div class="d-title">用户评论（{{ listTotal }}）</div>
            <div class="comment-content">
              <div
                class="comment-list"
                v-for="(item, index) in commentList"
                :key="'comment' + index"
              >
                <template v-if="item.user && item['user']['avatar']">
                  <div
                    class="c-img"
                    :style="{
                      backgroundImage:
                        'url( ' + imgUrl + item['user']['avatar'] + ')',
                    }"
                  ></div>
                </template>
                <template v-else>
                  <div class="c-img">
                    <i class="el-icon-user-solid"></i>
                  </div>
                </template>
                <div class="content-box">
                  <div class="name-date">
                    {{ item["user"] ? item["user"]["real_name"] : "暂无" }}
                    <!-- <span>{{ item.date }}</span> -->
                  </div>
                  <el-rate
                    v-model="item.evaluate"
                    disabled
                    :colors="scoreColor"
                  ></el-rate>
                  <div class="c-words">
                    {{ item.detail ? item.detail : "默认好评" }}
                  </div>
                  <div class="img-box" v-if="item.imgs">
                    <div
                      @click="lookCard(ele)"
                      class="img-list"
                      v-for="(ele, idx) in item.imgs"
                      :key="idx"
                      :style="{
                        backgroundImage: 'url( ' + imgUrl + ele + ')',
                      }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <el-pagination
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :page-size="page_size"
              :total="listTotal"
            ></el-pagination>
          </div>
        </div>
        <div class="right-box">
          <div class="detail-module">
            <div class="d-title">课程评价</div>
            <div class="second-title">平均评分</div>
            <div
              class
              v-for="(item, index) in detailInfo.evaluate"
              :key="'eva' + index"
            >
              <el-rate
                v-model="item.evaluate"
                disabled
                :colors="scoreColor"
              ></el-rate>
              <el-progress
                :format="progessFormat"
                :stroke-width="10"
                :percentage="item.count"
                :color="customColor"
              ></el-progress>
            </div>
          </div>
          <div class="detail-module">
            <div class="d-title course-title">推荐课程</div>
            <div
              class="course-list"
              @click="goCourseDetail(item, index)"
              v-for="(item, index) in detailInfo.recommend"
              :key="index"
            >
              <div
                class="c-img"
                :style="{
                  backgroundImage: 'url( ' + imgUrl + item['cover'] + ')',
                }"
              ></div>
              <div class="c-content">
                <div class="c-title">{{ item.title }}</div>
                <div class="c-box">
                  <div class="c-price">
                    <span>¥</span>
                    {{ item.price }}
                  </div>
                  {{ item.report_count }}人已购买
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 问卷表单 -->
    <el-dialog
      class="form-box"
      :visible.sync="formVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">问卷表单</div>
      <div class="peo-box" v-for="(item, index) in problemList" :key="index">
        <div class="form-question">{{ index + 1 }}.{{ item.title }}</div>
        <div class="rideo-box">
          <el-radio-group v-model="item.answer">
            <el-radio :label="item.option_A">{{ item.option_A }}</el-radio>
            <el-radio :label="item.option_B">{{ item.option_B }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="submit-button" @click="submit">提交表单</div>
    </el-dialog>

    <!-- 课程等级 -->
    <el-dialog
      class="form-box"
      :visible.sync="rankVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">选择课程等级</div>
      <div class="rideo-box rank-box">
        <el-radio
          v-for="(item, index) in rankList"
          :key="'rank' + index"
          v-model="rank"
          :label="item.level_id"
          @change="rankChange"
          >{{ getSectionTitle(detailInfo, item, index, false) }}</el-radio
        >
      </div>
      <div class="submit-button" @click="next">下一步</div>
    </el-dialog>
    <!-- 选择付款方式 -->
    <el-dialog
      class="form-box"
      :visible.sync="wayVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">选择付款方式</div>
      <div class="way-box">
        <div
          class="way-list"
          @click="waySelect(item, index)"
          v-for="(item, index) in wayList"
          :key="'way' + index"
          :class="index === wayIndex ? 'way-active' : ''"
        >
          <div
            class="active-img"
            :style="{ backgroundImage: 'url( ' + activeImg + ')' }"
          ></div>
          <i class="iconfont-icon" :class="item.icon"></i>
          {{ item.name }}
        </div>
      </div>
      <div class="submit-button" @click="wayNext">下一步</div>
    </el-dialog>
    <!-- 付款信息 -->
    <el-dialog
      class="form-box"
      :visible.sync="infoVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box first-box">
        <div class="t-title">课程名称：{{ wayInfo.order_name }}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{ wayInfo.order_amount }}</span>
        </div>
      </div>
      <div
        class="code-img"
        :style="{
          backgroundImage: 'url( ' + imgUrl + wayInfo['pay_url'] + ')',
        }"
      ></div>
      <div class="text-box">
        <div class="t-text">流水号：{{ wayInfo.order_sn }}</div>
        <div class="t-text">付款日期：{{ wayInfo.create_time }}</div>
      </div>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <!-- 付款信息2 -->
    <el-dialog
      class="form-box"
      :visible.sync="infoTwoVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box">
        <div class="t-title">课程名称：{{ wayInfo.course_title }}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{ wayInfo.order_money }}</span>
        </div>
      </div>
      <div class="text-box">
        <div class="t-text">流水号：{{ wayInfo.order_sn }}</div>
        <div class="t-text">付款日期：{{ wayInfo.create_time }}</div>
      </div>
      <div class="way-title">收款信息</div>
      <div class="money-box">
        <div class="money-info">
          公司名称：
          <span>{{ wayInfo.company_name }}</span>
        </div>
        <div class="money-info">
          开户银行：
          <span>{{ wayInfo.company_bank }}</span>
        </div>
        <div class="money-info">
          收款账号：
          <span>{{ wayInfo.company_no }}</span>
        </div>
      </div>
      <template v-if="wayInfo.pay_state === 0">
        <div class="way-title">付款凭证</div>
        <div class="tip-text">*请打款到指定收款账号并上传支付凭证截图</div>
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :on-success="successUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </template>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <!-- 查看图片 -->
    <el-dialog class="form-box" :visible.sync="dialogVisible" width="600PX">
      <div
        class="dialog-img"
        :style="{ backgroundImage: 'url( ' + imgUrl + imgInfo + ')' }"
      ></div>
      <!-- <div class="d-title">{{ imgInfo.title }}</div> -->
      <!-- <div class="download-btn" @click="downloadCard">下载证书</div> -->
    </el-dialog>
  </div>
</template>
<script>
import bannerImg from "../components/bannerImg.vue";
import videoPlayer from "../components/videoPlayer.vue";
import api from "../api/api";
import { upload_url } from "../api/index";
import { imgUrl } from "../api/index";
import selectImg from "@/assets/img/gouxuan_bg.png";

export default {
  name: "courseDetail",
  components: {
    bannerImg,
    videoPlayer,
  },
  data() {
    return {
      activeImg: selectImg,
      imgUrl: imgUrl,
      bannerText: "课程详情",
      detailTitle: "",
      videoUrl: "",
      questionList: [],
      info: {
        imgUrl: "",
        teacher: "",
        score: "",
        evaluateNum: "145",
        type: "",
        num: 0,
      },
      imgList: [],
      commentList: [],
      scoreColor: ["#FF9C00", "#FF9C00", "#FF9C00", "#FF9C00", "#FF9C00"],
      listTotal: 0,
      fiveScore: 5,
      fourScore: 5,
      threeScore: 3,
      twoScore: 2,
      oneScore: 1,
      customColor: "#FCB082",
      formVisible: false,
      isStudyList: ["是", "否"],
      isStudy: "",
      channelList: ["朋友介绍", "百度", "朋友圈"],
      channel: "",
      experienceList: ["1年", "2-3年", "3年以上", "没有"],
      experience: "",
      rankVisible: false,
      rankList: [],
      rank: "",
      wayList: [
        // 付款方式
        {
          icon: "icon-weixinfukuan",
          name: "微信支付",
          id: 2,
        },
        {
          icon: "icon-zhifubao",
          name: "支付宝支付",
          id: 1,
        },
        {
          icon: "icon-duigongzhuanzhang",
          name: "对公转账",
          id: 3,
        },
        {
          icon: "icon-xianjinzhifu",
          name: "现金支付",
          id: 4,
        },
      ],
      pay_type: "",
      wayIndex: "",
      wayVisible: false,
      wayInfo: {},
      infoVisible: false,
      infoTwoVisible: false,
      uploadUrl: upload_url, // 上传地址
      fileList: [],
      detailInfo: {},
      page_index: 1,
      detailId: "",
      page_size: 5,
      problemList: [],
      pay_img: "",
      bannerList: [],
      loading: false,
      imgInfo: "",
      dialogVisible: false,
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value) {
      this.getDetail(value.id);
      this.detailId = value.id;
      this.getCourseComment();
    }
  },
  methods: {
    // 获取课程标题
    getSectionTitle(detail, item, index, showLevelId = true) {
      if (index == 0 && detail.high_alias) return detail.common_alias;
      if (index == 1 && detail.middle_alias) return detail.primary_alias;
      if (index == 2 && detail.primary_alias) return detail.middle_alias;
      if (index == 3 && detail.common_alias) return detail.high_alias;
      return `${showLevelId ? item.level_id + " " : ""}${item.level_name}`;
    },

    lookCard(item) {
      this.imgInfo = item;
      this.dialogVisible = true;
    },
    // 课程详情跳转
    goCourseDetail(item, index) {
      this.$router.push({
        path: "/courseDetail",
        query: { id: item.uuid },
      });
    },
    //  获取详情
    getDetail(id) {
      api.getCourseDetail({ uuid: id }).then((res) => {
        console.log(res);
        if (res.result) {
          this.detailInfo = res.result;
          this.detailInfo.detail = this.detailInfo.detail.replace(
            /&(amp|gt|lt|quot|#39|nbsp);/g,
            (a) => {
              return {
                "&lt;": "<",
                "&amp;": "&",
                "&quot;": '"',
                "&gt;": ">",
                "&#39;": "'",
                "&nbsp;": " ",
              }[a];
            }
          );
          this.detailInfo.detail = this.changeShowImg(this.detailInfo.detail);
          this.problemList = res.result.problem;
          this.bannerList = JSON.parse(res.result.banner);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    changeShowImg(obj) {
      const baseImg = "https://train-service-api.procaregroup.com/";
      const objstr = JSON.stringify(obj);
      const midStr = "train_service/app_upload";
      const str = objstr.replace(new RegExp(baseImg, "g"), "");
      const str1 = str.replace(
        new RegExp(midStr, "g"),
        "https://train-service-api.procaregroup.com/train_service/app_upload"
      );
      return JSON.parse(str1);
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getCourseComment();
    },
    // 获取评论
    getCourseComment() {
      const params = {
        course_uuid: this.detailId,
        page_index: this.page_index,
        page_size: this.page_size,
      };
      api.getCourseComment(params).then((res) => {
        console.log(res);
        if (res.result) {
          this.commentList = res.result.data;
          this.listTotal = res.result.total;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    progessFormat(percentage) {
      console.log(percentage);
      return percentage;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 个人档案信息获取
    getMyInformation() {
      api.getMyInformation().then((res) => {
        console.log(res);
      });
    },
    // 立即报名
    signUp() {
      // this.formVisible = true;
      api.getMyinfo().then((res) => {
        console.log(res);
        if (res.result) {
          if (res.result.is_archive === 1) {
            // 已经填过表单的直接选课程等级
            if (this.detailInfo.couser_problem_user.is_done === 1) {
              this.rankVisible = true;
              this.rankList = this.detailInfo.couser_problem_user.allow;
            } else {
              this.formVisible = true;
            }
          } else {
            this.$router.push({ path: "/userProfiles" });
          }
        } else {
          this.$message.warning("请登录！");
          location.reload();
        }
      });
    },
    // 是否学习过
    isStudyChange(val) {
      console.log(val);
    },
    // 哪些渠道
    channelChange(val) {
      console.log(val);
    },
    // 从业经验
    experienceChange(val) {
      console.log(val);
    },
    // 提交表单
    submit() {
      let isNotComplete = [];
      for (let i = 0; i < this.problemList.length; i++) {
        console.log(i, this.problemList[0].answer);
        if (this.problemList[i].answer && this.problemList[i].answer !== "") {
          isNotComplete.push("");
        }
      }
      if (isNotComplete.length == this.problemList.length) {
        api.courseCheck(this.problemList).then((res) => {
          if (res.result && res.result.length > 0) {
            this.rankList = res.result;
            this.formVisible = false;
            this.rankVisible = true;
          } else {
            this.$message.warning("不符合报名条件！");
          }
        });
      } else {
        this.$message.warning("请完成表单填写！");
      }
    },
    // 课程等级
    rankChange(val) {
      console.log(val, this.rank);
      this.rank = val;
    },
    // 下一步
    next() {
      if (!this.rank) {
        this.$message.warning("请选择课程等级！");
      } else {
        this.rankVisible = false;
        this.wayVisible = true;
      }
    },
    // 支付方式选择
    waySelect(item, index) {
      console.log(item, index);
      this.pay_type = item.id;
      this.wayIndex = index;
    },
    // 付款方式后下一步
    wayNext() {
      if (!this.pay_type) {
        this.$message.warning("请选择付款方式！");
      } else {
        this.loading = true;
        const params = {
          pay_type: this.pay_type,
          course_uuid: this.detailId,
          level_id: this.rank,
        };
        const that = this;
        api.courseOrder(params).then((res) => {
          console.log(res);
          if (res.result) {
            console.log(res.result.pay_state);
            if (this.pay_type === 3) {
              this.wayInfo = res.result;
              this.wayVisible = false;
              this.infoTwoVisible = true;
              this.loading = false;
              return;
            }
            if (res.result.pay_state == 1) {
              that.wayVisible = false;
            } else {
              that.commodityPay(res.result.order_sn);
            }
            this.loading = false;
          } else {
            this.$message.warning(res.message);
            this.loading = false;
          }
        });
      }
    },
    commodityPay(order_sn) {
      api.commodityPay({ order_sn: order_sn }).then((res) => {
        console.log(res);
        if (res.result) {
          this.wayInfo = res.result;
          this.wayVisible = false;
          if (this.pay_type === 3) {
            this.infoTwoVisible = true;
            return;
          }
          this.infoVisible = true;
        } else {
          this.$message.warning("订单信息有误！");
        }
        this.loading = false;
      });
    },
    // 已支付
    havePay() {
      if (this.infoVisible === true) {
        this.infoVisible = false;
        return;
      }
      if (this.wayInfo.pay_state === 1) {
        this.infoTwoVisible = false;
        return;
      }
      if (!this.pay_img) {
        this.$message.warning("请上传支付凭证！");
        return;
      }
      api
        .uploadPlayImg({
          order_sn: this.wayInfo.order_sn,
          pay_img: this.pay_img,
        })
        .then((res) => {
          console.log(res);
          if (res.result) {
            this.$message.success("上传成功！");
            this.infoTwoVisible = false;
          }
        });
    },
    // 凭证移除
    handleRemove(file) {
      console.log(file);
      this.pay_img = "";
    },
    // 上传成功
    successUpload(res, file, fileList) {
      console.log(res);
      if (res.result) {
        this.pay_img = res.result;
        this.$message.success("上传成功！");
      } else {
        this.$message.warning("上传失败！");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.course-container {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.nav-box {
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.detail-title {
  padding: 40px 0;
  font-size: 26px;
  color: #333333;
  font-weight: bold;
}
.video-content {
  //   display: flex;
}
.video-box {
  width: 100%;
  .v-img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.question-box {
  width: 28%;
  padding-left: 30px;
  background-color: #1e1e1e;
  overflow: auto;
  .q-title {
    padding: 6px 0 15px;
    margin-bottom: 28px;
    font-size: 22px;
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
  }
  .second-title {
    padding-top: 20px;
  }
}
.q-words {
  // display: flex;
  width: 100%;
  padding-right: 10px;
  margin-bottom: 24px;
  font-size: 16px;
  color: #ffffff;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    color: #f1a373;
  }
}
.q-type {
  display: inline-block;
  width: 36px;
  height: 20px;
  margin-right: 16px;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  background-color: #ff7b1f;
  border-radius: 5px;
}
.type-green {
  background-color: #52ce0f;
}
.detail-info-box {
  display: flex;
  align-items: center;
  padding: 30px 32px;
  margin-bottom: 22px;
  background-color: #282828;
  .info-img {
    width: 70px;
    height: 70px;
    margin-right: 16px;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: antiquewhite;
  }
  .module-box {
    font-size: 18px;
    color: #ffffff;
    .name {
      padding-bottom: 8px;
      font-size: 16px;
      color: rgba($color: #ffffff, $alpha: 0.8);
    }
    span {
      font-size: 14px;
    }
  }
  .line {
    padding: 0 48px;
    font-size: 18px;
    color: #ffffff;
  }
  .sign-up-button {
    width: 367px;
    height: 66px;
    margin-left: 100px;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 66px;
    font-weight: 600;
    letter-spacing: 2px;
    background-color: #f1a373;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.detail-content {
  display: flex;
  justify-content: space-between;
}
.left-box {
  width: 67%;
}
.right-box {
  width: 30%;
}
.detail-module {
  padding: 25px;
  margin-bottom: 20px;
  background-color: #ffffff;
  .d-title {
    position: relative;
    padding-bottom: 16px;
    font-size: 20px;
    color: #f1a373;
    border-bottom: 1px solid #ececec;
    &::after {
      position: absolute;
      left: 12px;
      bottom: 0;
      width: 55px;
      height: 3px;
      background-color: #f1a373;
      content: "";
    }
  }
  .second-title {
    padding: 32px 0 18px;
    font-size: 16px;
    color: #333333;

    .el-icon-arrow-down,
    .el-icon-arrow-up {
      float: right;
      cursor: pointer;
    }
  }
  .iconfont-icon {
    margin-top: 22px;
    font-size: 30px;
    color: #f1a373;
    cursor: pointer;
  }
  .q-words {
    padding: 0 28px;
    margin-bottom: 10px;
    font-size: 14px;
    color: #333333;
    line-height: 40px;
    background-color: #f5f5f5;
  }
  .q-type {
    margin-right: 10px;
    font-size: 14px;
  }
}

.teacher-box {
  display: flex;
  height: 137px;
  //   flex-wrap: wrap;
  overflow-x: hidden;
  &:hover {
    overflow-x: auto;
  }

  .t-list {
    flex-shrink: 0;
    display: flex;
    width: 50%;
    // margin-bottom: 30PX;
  }
  .teacher-img {
    width: 102px;
    height: 102px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.teacher-words {
  flex: 1;
  margin-right: 62px;
  font-size: 12px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  .t-name {
    padding-bottom: 5px;
    font-size: 18px;
    color: #333333;
  }
}
.intro-words {
  font-size: 16px;
  //   overflow: auto;
  //   >>> p {
  //     white-space: nowrap;
  //   }
}
.img-box {
  display: flex;
  //   align-items: center;
  height: 167px;
  //   flex-wrap: wrap;
  overflow-x: hidden;
  &:hover {
    overflow-x: auto;
  }
  .img-list {
    flex-shrink: 0;
    width: 212px;
    height: 152px;
    margin-right: 47px;
    // background-color: #eeeeee;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }
  .iconfont-icon {
    margin-left: 62px;
  }
}
.comment-content {
  padding: 48px 0 35px;
}
.comment-list {
  display: flex;
  margin-bottom: 30px;
  .c-img {
    width: 64px;
    height: 64px;
    margin-right: 22px;
    text-align: center;
    background-color: #ececec;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    i {
      font-size: 44px;
      color: #ffffff;
      line-height: 64px;
    }
  }
  .content-box {
    flex: 1;
  }
  .name-date {
    display: flex;
    justify-content: space-between;
    padding-bottom: 4px;
    font-size: 16px;
    font-weight: bold;
    span {
      font-size: 14px;
      color: #999999;
      font-weight: normal;
    }
  }
  .img-box {
    display: flex;
  }
  .img-list {
    width: 33%;
    cursor: pointer;
  }
  .c-words {
    padding-top: 4px;
    margin-bottom: 20px;
    line-height: 26px;
  }
}
/deep/ {
  .el-carousel__indicators--horizontal {
    display: none;
  }
  .el-image {
    height: 100%;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination {
    text-align: center;
    button {
      width: 42px;
      height: 42px;
    }
  }
  .el-collapse-item__header {
    margin-bottom: 20px;
    border: none;
  }
  .el-collapse {
    border: none;
  }
  .el-pager li {
    width: 42px;
    height: 42px;
    line-height: 42px;
  }
  .el-progress__text {
    position: absolute;
    top: -20px;
    right: 10px;
    font-size: 14px;
    color: #2c2c2c;
  }
  .el-progress-bar {
    padding-right: 0;
  }
  .el-progress {
    margin-bottom: 22px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #f1a475;
    background: #f1a475;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #f1a475;
  }
  .el-dialog {
    padding: 0 20px 0;
    border-radius: 9px;
  }
}
.course-title {
  margin-bottom: 40px;
}
.course-list {
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    .c-title {
      color: #fb6d0a;
    }
  }
  .c-img {
    height: 220px;
    background-color: #ececec;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .c-content {
    padding: 14px 16px;
    border: 1px solid #ededed;
    border-top: none;
  }
  .c-title {
    padding-bottom: 6px;
  }
  .c-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #888888;
  }
  .c-price {
    font-size: 22px;
    color: #dd0707;
    span {
      font-size: 14px;
    }
  }
}
.form-box {
  .form-title {
    padding-bottom: 38px;
    font-size: 22px;
    text-align: center;
  }
  .form-question {
    padding-bottom: 16px;
    font-size: 16px;
  }
  .rideo-box {
    margin-bottom: 30px;
  }
  .submit-button {
    width: 218px;
    height: 52px;
    margin: 52px auto 0;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 52px;
    background-color: #f1a373;
    border-radius: 45px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .rank-box {
    text-align: center;
  }
  .way-box {
    display: flex;
    flex-wrap: wrap;
    // width: 76%;
    margin: 0 auto;
  }
  .way-list {
    position: relative;
    display: flex;
    align-items: center;
    width: 162px;
    height: 50px;
    margin-bottom: 14px;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #cbcbcb;
    margin-right: -10px;
    cursor: pointer;
    margin-right: 10px;
    &:nth-child(2n) {
      // margin-left: 45px;
    }
    &:hover {
      border-color: #f1a475;
      .active-img {
        display: block;
      }
    }
    .iconfont-icon {
      padding: 0 14px 0 24px;
      font-size: 28px;
      line-height: 50px;
    }
  }
  .way-active {
    border-color: #f1a475;
    .active-img {
      display: block;
    }
  }
  .active-img {
    position: absolute;
    display: none;
    top: 0;
    right: -1px;
    width: 28px;
    height: 28px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .icon-weixinfukuan {
    color: #6bcc03;
  }
  .icon-zhifubao {
    color: #189fe4;
  }
  .icon-duigongzhuanzhang {
    color: #faad14;
  }
  .icon-xianjinzhifu {
    color: #f8b551;
  }
  .text-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t-text:last-child {
      padding-left: 20px;
    }
  }
  .first-box {
    margin-bottom: 20px;
  }
  .t-title {
    width: 50%;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-text {
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    span {
      font-size: 30px;
      color: #c00c0c;
    }
  }
  .code-img {
    width: 358px;
    height: 322px;
    margin: 0 auto 32px;
    background-color: #d8d8d8;
    border: 1px solid #979797;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .have-btn {
    margin-top: 20px;
  }
  .way-title {
    padding: 40px 0 12px;
    margin-bottom: 22px;
    font-size: 16px;
    color: #f1a475;
    border-bottom: 1px solid #e7e7e7;
  }
  .money-box {
    padding: 14px 8px;
    background-color: #f6f6f6;
  }
  .money-info {
    padding-bottom: 14px;
    color: #666666;
    span {
      color: #000000;
    }
  }
  .tip-text {
    padding-bottom: 22px;
    color: #f90000;
  }
}
@media screen and (max-width: 1800px) {
  .course-container {
    width: 90%;
  }
}
@media screen and (max-width: 1600px) {
  .course-container {
    width: 96%;
  }
}
@media screen and (max-width: 1450px) {
  .course-container {
    width: 100%;
  }
}
.dialog-img {
  width: 90%;
  height: 445px;
  margin: 0 auto 26px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/views/courseDetail.vue